/**
 *
 * Asynchronously loads the component for TeamDetails
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
